import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useInvoice = (id) => useQuery({
    queryKey: ['invoice', id],
    queryFn: async () => {
        if (!id) return null
        const { data } = await API.get(`/invoices/${id}`)
        return data
    },
    enabled: !!id
})

export default useInvoice
